export default "__VITE_ASSET__DcvijRv9__"